var _style, _g, _defs, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickpea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004137;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FDCB7C;}\n\t.st2{fill:#FFEBC4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M145.52,100.1c-4.97-13.62-17.98-28.08-34.26-29.39c-0.19-0.02-0.37-0.02-0.56-0.03 c-1.4-2.96-4.56-5.04-8.25-5.04c-4.91,0-8.89,3.67-9,8.23c-0.4,0.17-0.63,0.29-0.63,0.29c-0.96,0.48-4.43,2.27-8.51,6.08 c-2.46,2.29-11.47,10.7-14.19,24.53c-2.76,14.05,1.4,31.56,11.15,37.09c5.03,2.86,10.34,3.04,10.34,3.04 c3.83,0.15,7-0.83,8.92-1.42c4.64-1.42,6.33-3.05,11.15-3.65c1.7-0.21,3.09-0.21,3.85-0.2c4.25,0.03,6.84,0.88,8.72,1.22 c6.94,1.25,13.34-2.82,13.99-3.24c5.34-3.5,7.12-9.01,8.31-12.16C150.72,114.34,147.04,104.26,145.52,100.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FED998"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.16,72.51c5.43,0.7,14.37,2.65,23.4,8.74c3.99,2.69,10.79,7.4,15.5,16.42c1.64,3.13,5.98,11.72,4.4,22.73 c-1.08,7.48-4.39,12.61-5.27,13.92c-2.69,4-5.75,6.6-7.86,8.13c4.4,0.72,8.8,1.43,13.19,2.15c2.72-0.35,14-2.12,21.28-11.82 c7.21-9.6,5.71-20.59,4.96-26.08c-2.23-16.27-12.84-26.39-20.73-33.89c-7.46-7.1-16.62-15.83-28.98-15.54 c-2.78,0.07-10.22,0.24-15.42,5.87C86.52,66.48,85.52,70.37,85.16,72.51z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9917 -0.1289 0.1289 0.9917 -13.7318 12.6329)",
    className: "st2",
    cx: 90.69,
    cy: 112.36,
    rx: 6.08,
    ry: 20.47
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickpea);
export default __webpack_public_path__ + "static/media/Chickpea.3a51f0a56ab7dc1793158ac11009879c.svg";
export { ForwardRef as ReactComponent };